<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block" translate>List Label</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="list_label" [(ngModel)]="component.element.list_label" (ngModelChange)="onLabelChange($event)">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block" translate>Field name</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="field_name" [(ngModel)]="component.element.field_name" #fieldName="ngModel" 
      required pattern="^[^\s\W]+$" maxlength="100"
      ngModelOptions="{ updateOn: 'blur' }"
      (blur)="sanitizeFieldName()"
      (keydown)="preventSpecialChar($event)"
      (input)="filterSpecialCharOnInput()"
      >
      <mat-hint translate>Max 100 characters</mat-hint>
      <mat-error *ngIf="fieldName.invalid && fieldName.touched">
        Field name is mandatory and should not contain spaces or special characters.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block">Select List Type</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.listtype" #listType="ngModel" required
        (selectionChange)="onChangeListType($event)">
        <mat-option value="" disabled>Select List Type</mat-option>
        <!-- <mat-option value="checklist">Check List</mat-option> -->
        <mat-option value="dataviewlist">Data View List(Form)</mat-option>
        <mat-option value="reportlist">Summary Report List</mat-option>
        <mat-option value="inputlist">List As Input</mat-option>
      </mat-select>
      <mat-error *ngIf="listType.invalid && listType.touched">
        List Type is mandatory.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.listtype === 'reportlist'">
  <div class="col-sm-12">
    <label class="d-block">Select Form</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.tableName" #tableName="ngModel" panelClass="testClass" name="Status">
        <mat-select-filter [placeholder]="'Search'" [displayMember]="'form_name'" [array]="pageList"
          (filteredReturn)="filteredPages = $event"></mat-select-filter>
        <mat-option *ngFor="let page of filteredPages" [value]="page.id">
          {{page.form_name}}
        </mat-option>
      </mat-select>
      <mat-error class="error-msg" *ngIf="tableName.invalid && tableName.touched">Page field is required</mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block">Select Data Source Type</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.datasource" #datasourceType="ngModel" required
        (selectionChange)="onChangeDatasourcetype($event)">
        <mat-option value="" disabled>Select Data Source Type</mat-option>
        <mat-option value="value">Value</mat-option>
        <mat-option value="url">API/URL</mat-option>
        <!-- <mat-option value="query">Custom Query</mat-option> -->
      </mat-select>
      <mat-error *ngIf="datasourceType.invalid && datasourceType.touched">
        Data Source Type is mandatory.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block">Choose API</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.apiEndpoint" (selectionChange)="onChangeAPI($event.value)">
        <mat-select-filter [placeholder]="'Search'" [displayMember]="'APIAliasName'" [array]="apiList"
          (filteredReturn)="filteredAPIS = $event"></mat-select-filter>
        <mat-option *ngFor="let api of filteredAPIS" [value]="api.id">
          {{ api.APIAliasName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Http Request Type (GET, POST, PUT...)</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="requestType" placeholder="get, post, put, patch, delete"
        [(ngModel)]="component.element.requestType">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Data Source URL</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="datasourceurl" [(ngModel)]="component.element.datasourceUrl">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Data Source Parameters (JSON)</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="datasourceparameters" placeholder="{'EG_Id': 0, 'PT_Id': 0}"
        [(ngModel)]="component.element.datasourceParamaters">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>ResultSet (List) Name</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="resultsetName" placeholder="groupList" [(ngModel)]="component.element.resultsetName">
    </mat-form-field>
  </div>
</div>

<!-- ══════════════ URL datasource — Column Definitions ══════════════ -->
<div class="col-sm-12" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Column Definition list</label>
  <table class="table table-sm">
    <tbody>
      <tr *ngFor="let option of component.element.columnDefs; let idx = index;">
        <td class="text-center align-middle">
          <button class="btn btn-sm text-danger" (click)="addColDefs()">
            <i class="fas fa-add color-blue"></i>
          </button>
          <button class="btn btn-sm text-danger" (click)="removeColumns(idx)">
            <i class="fas fa-trash color-red"></i>
          </button>
        </td>
        <td>
          <div class="input-group input-group-sm mb-1">
            <span class="input-group-text option-key-value" translate>Header Name</span>
            <input type="text" class="form-control" [placeholder]="'header ' + idx" [(ngModel)]="option.headerName" (ngModelChange)="onColumnHeaderChange($event, idx)" maxlength="100" />
          </div>
          <div class="input-group input-group-sm">
            <span class="input-group-text option-key-value" translate>Field Name</span>
            <input type="text" class="form-control" [placeholder]="'field ' + idx" [(ngModel)]="option.field" />
          </div>
          <div style="margin: 5px;">
            <div style="display: flex; flex-wrap: wrap;">
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Editable</span>
                <input type="checkbox" [(ngModel)]="option.editable"
                       [disabled]="option.cellEditorCheckbox || option.cellEditorSelect" />
              </div>
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Sortable</span>
                <input type="checkbox" [(ngModel)]="option.sortable" />
              </div>
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Resizable</span>
                <input type="checkbox" [(ngModel)]="option.resizable" />
              </div>
              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Dropdown Cell</span>
                <input type="checkbox" [(ngModel)]="option.cellEditorSelect"
                       (change)="option.cellEditorCheckbox = false; option.editable = false" />
              </div>
              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Checkbox Cell</span>
                <input type="checkbox" [(ngModel)]="option.cellEditorCheckbox"
                       (change)="option.cellEditorSelect = false; option.editable = false" />
              </div>
              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <input *ngIf="option.cellEditorSelect" type="text" class="form-control" placeholder="Ex: Yes, No"
                  [(ngModel)]="option.cellEditorParamsValues" />
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <button class="btn btn-link btn-sm" (click)="addColumns()">
    <i class="fas fa-plus me-2"></i> <span>Add Columns</span>
  </button>
  <div class="row mb-2">
    <div class="col-sm-12">
      <label class="d-block" translate>Pagination Page Size</label>
      <mat-form-field appearance="outline" class="w-100 no-outline">
        <input matInput type="number" name="paginationPageSizeValue" min="1" placeholder="e.g. 10" [(ngModel)]="component.element.paginationPageSize" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);"  />
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-sm-12">
      <label class="d-block" translate>Grid Height (px)</label>
      <mat-form-field appearance="outline" class="w-100 no-outline">
        <input matInput type="number" name="gridHeight" min="100" placeholder="e.g. 500" [(ngModel)]="component.element.gridHeight" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);"  />
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-sm-12">
      <div class="d-flex flex-wrap align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="buttonEditUrl" [(ngModel)]="component.element.buttonEdit" />
          <label class="form-check-label" for="buttonEditUrl" translate style="color: blue;">
            Add Edit Button
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="buttonDeleteUrl" [(ngModel)]="component.element.buttonDelete" />
          <label class="form-check-label" for="buttonDeleteUrl" translate style="color: red;">
            Add Delete Button
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════ VALUE datasource — Column Definitions ══════════════ -->
<div class="row mb-2" *ngIf="component.element.datasource === 'value'">
  <label class="col-sm-12" translate>Column Definition list</label>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let option of component.element.columnDefs; let idx = index;">
          <td class="text-center align-middle">
            <button class="btn btn-sm text-danger" (click)="addColDefs()">
              <i class="fas fa-add color-blue"></i>
            </button>
            <button class="btn btn-sm text-danger" (click)="removeColumns(idx)">
              <i class="fas fa-trash color-red"></i>
            </button>
          </td>
          <td>
            <div class="input-group input-group-sm mb-1">
              <span class="input-group-text option-key-value" translate>Header Name</span>
              <input type="text" class="form-control" [placeholder]="'header ' + idx" [(ngModel)]="option.headerName" (ngModelChange)="onColumnHeaderChange($event, idx)" maxlength="100" />
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Field Name</span>
              <input type="text" class="form-control" [placeholder]="'field ' + idx" [(ngModel)]="option.field" />
            </div>
            <div style="margin: 5px;">
              <div style="display: flex; flex-wrap: wrap;">
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Editable</span>
                  <input type="checkbox" [(ngModel)]="option.editable"
                         [disabled]="option.cellEditorCheckbox || option.cellEditorSelect" />
                </div>
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Sortable</span>
                  <input type="checkbox" [(ngModel)]="option.sortable" />
                </div>
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Resizable</span>
                  <input type="checkbox" [(ngModel)]="option.resizable" />
                </div>
                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Dropdown Cell</span>
                  <input type="checkbox" [(ngModel)]="option.cellEditorSelect"
                         (change)="option.cellEditorCheckbox = false; option.editable = false" />
                </div>
                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Checkbox Cell</span>
                  <input type="checkbox" [(ngModel)]="option.cellEditorCheckbox"
                         (change)="option.cellEditorSelect = false; option.editable = false" />
                </div>
                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <input *ngIf="option.cellEditorSelect" type="text" class="form-control" placeholder="Ex: Yes, No"
                    [(ngModel)]="option.cellEditorParamsValues" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <button class="btn btn-link btn-sm" (click)="addColumns()">
      <i class="fas fa-plus me-2"></i> <span>Add Columns</span>
    </button>
    <button class="btn btn-link btn-sm" (click)="openAGGridDataModel()">
      <i class="fas fa-plus me-2"></i> <span>Add Data</span>
    </button>

    <div class="row mb-2">
      <div class="col-sm-12">
        <label class="d-block" translate>Pagination Page Size</label>
        <mat-form-field appearance="outline" class="w-100 no-outline">
          <input matInput type="number" name="paginationPageSizeValue" min="1" placeholder="e.g. 10" [(ngModel)]="component.element.paginationPageSize" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);">
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <label class="d-block" translate>Grid Height (px)</label>
        <mat-form-field appearance="outline" class="w-100 no-outline">
          <input matInput type="number" name="gridHeightValue" min="100" placeholder="e.g. 500" [(ngModel)]="component.element.gridHeight" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);">
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="d-flex flex-wrap align-items-center gap-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="buttonEditValue" [(ngModel)]="component.element.buttonEdit" />
            <label class="form-check-label" for="buttonEditValue" translate style="color: blue;">
              Add Edit Button
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="buttonDeleteValue" [(ngModel)]="component.element.buttonDelete" />
            <label class="form-check-label" for="buttonDeleteValue" translate style="color: red;">
              Add Delete Button
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- ══════════════════════════════════════════════════════════════════════════
     ADD DATA DIALOG
     - "Generate Rows" creates N blank rows in one click
     - "+ Add Row" appends one blank row manually
     - Checkbox / Dropdown / Text inputs per column type
     - "Add to Grid" binds all rows into the live AG Grid
     ══════════════════════════════════════════════════════════════════════════ -->
<ng-template #AgGridRowDataPoup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h1 class="main-title mb-0">Add Row Data</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>

    <!-- ── Generate Rows bar ─────────────────────────────────────────────── -->
    <div class="d-flex align-items-center gap-2 mb-3 p-2"
         style="background: #f8f9fa; border-radius: 6px; border: 1px solid #e9ecef;">
      <span style="font-size: 0.85rem; white-space: nowrap; color: #495057;">Generate Rows:</span>
      <input type="number"
             class="form-control form-control-sm"
             style="width: 80px;"
             min="1" max="500"
             [(ngModel)]="dialogInitialRowCount"
             placeholder="e.g. 5" />
      <button class="btn btn-outline-primary btn-sm"
              style="white-space: nowrap;"
              (click)="generateDialogRows()">
        <i class="fas fa-table me-1"></i> Generate
      </button>
      <span *ngIf="dialogRows.length"
            class="ms-auto text-muted"
            style="font-size: 0.8rem;">
        {{ dialogRows.length }} row(s) ready
      </span>
    </div>
  </div>

  <div mat-dialog-content style="overflow-x: auto; padding: 0 16px 8px; max-height: 55vh;">

    <!-- No columns guard -->
    <div *ngIf="!dialogColumns.length" class="text-muted text-center py-3">
      <i class="fas fa-info-circle me-2"></i>No columns found. Please add and apply columns first.
    </div>

    <!-- Row data table -->
    <table class="table table-sm table-bordered align-middle"
           *ngIf="dialogColumns.length"
           style="min-width: 100%;">
      <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
        <tr>
          <th class="text-center" style="width: 36px;">#</th>
          <th *ngFor="let col of dialogColumns" class="text-nowrap">
            {{ col.headerName || col.field }}
            <span *ngIf="col.cellEditorSelect"
                  class="badge bg-info ms-1"
                  style="font-size: 0.65rem;"
                  title="Dropdown">▼</span>
            <span *ngIf="col.cellEditorCheckbox"
                  class="badge bg-success ms-1"
                  style="font-size: 0.65rem;"
                  title="Checkbox">✓</span>
          </th>
          <th class="text-center" style="width: 40px;">Del</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of dialogRows; let ri = index;">
          <td class="text-center text-muted small align-middle">{{ ri + 1 }}</td>

          <td *ngFor="let col of dialogColumns" class="align-middle" style="min-width: 100px;">

            <!-- Checkbox cell -->
            <div *ngIf="col.cellEditorCheckbox" class="d-flex justify-content-center">
              <input type="checkbox"
                     [(ngModel)]="row[col.field]"
                     style="width: 18px; height: 18px; cursor: pointer;" />
            </div>

            <!-- Dropdown cell -->
            <select *ngIf="col.cellEditorSelect && !col.cellEditorCheckbox"
                    class="form-select form-select-sm"
                    [(ngModel)]="row[col.field]">
              <option value="">— select —</option>
              <option *ngFor="let opt of parseDropdownValues(col.cellEditorParamsValues)"
                      [value]="opt">{{ opt }}</option>
            </select>

            <!-- Text cell -->
            <input *ngIf="!col.cellEditorCheckbox && !col.cellEditorSelect"
                   type="text"
                   class="form-control form-control-sm"
                   [(ngModel)]="row[col.field]"
                   [placeholder]="col.headerName || col.field" />
          </td>

          <!-- Delete row -->
          <td class="text-center align-middle">
            <button class="btn btn-sm btn-outline-danger"
                    style="padding: 2px 7px;"
                    title="Remove this row"
                    (click)="removeDialogRow(ri)">
              <i class="fas fa-trash" style="font-size: 0.75rem;"></i>
            </button>
          </td>
        </tr>

        <!-- Empty state -->
        <tr *ngIf="!dialogRows.length">
          <td [attr.colspan]="dialogColumns.length + 2"
              class="text-center text-muted py-3 fst-italic">
            No rows yet — use "Generate Rows" or click "+ Add Row" below.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Dialog footer -->
  <div mat-dialog-actions
       class="d-flex justify-content-between align-items-center px-3 pb-3 pt-2"
       style="border-top: 1px solid #e9ecef;">

    <!-- Add one blank row -->
    <button mat-stroked-button
            color="primary"
            [disabled]="!dialogColumns.length"
            (click)="addDialogRow()">
      <i class="fas fa-plus me-1"></i> Add Row
    </button>

    <!-- Cancel + Add to Grid -->
    <div class="d-flex gap-2">
      <button mat-stroked-button mat-dialog-close>Cancel</button>

      <button mat-raised-button
              color="primary"
              [disabled]="!dialogRows.length"
              (click)="saveDialogRows()">
        <i class="fas fa-check me-1"></i>
        Add to Grid
        <span *ngIf="dialogRows.length" class="badge bg-white text-primary ms-1">
          {{ dialogRows.length }}
        </span>
      </button>
    </div>
  </div>
</ng-template>